import {Component, OnInit} from '@angular/core';
import {RecipientModel} from '../../../../models/recipient.model';
import {SharedService} from '../../../../services/shared.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LOCATIONS} from '../../../../global';
import * as _ from 'lodash';

@Component({
  selector: 'app-recipient',
  templateUrl: './recipient.component.html',
  styleUrls: ['./recipient.component.scss']
})
export class RecipientComponent implements OnInit {
  recipients: Array<RecipientModel>;
  selectedRecipient: RecipientModel;
  selectedLocation: string;
  locations: Array<any> = LOCATIONS;
  feetValue: number = 20;
  recipientForm: FormGroup;

  constructor(private shared: SharedService,
              private router: Router,
              private fb: FormBuilder) {
    this.shared.sendEvent({type: 'request_step', data: {step: 2, name: 'REQUEST.RECIPIENT.NAME'}});
    this.recipients = [
      new RecipientModel({name: 'Vessel', short: 'vessel', id: '-Kly_3fgah8A-2Q4geLa', status: true}),
      new RecipientModel({name: 'On-Site Tank', short: 'tank', id: '-Kly_syD7kKMRuRbOykS', status: true}),
      new RecipientModel({name: 'Generator', short: 'generator', id: '-KlyaCZl9kltzd05nXhN', status: true})
    ];
    this.recipientForm = this.fb.group({
      location: [null, Validators.required],
      feet: [20, Validators.required],
      name: [null, Validators.required],
      comments: [null]
    });
    if (this.shared.getStep() != 'recipient') this.router.navigate(['account', 'request', 'fuel']);
  }

  ngOnInit() {
  }

  setSelectedRecipient(recipient?: RecipientModel) {
    let timeOut = 10;
    if (recipient) timeOut = 1;
    setTimeout(() => {
      this.selectedRecipient = recipient;
      if (!recipient) this.recipientForm.reset();
    }, timeOut);
  }

  recipientClassChecker(recipient: RecipientModel) {
    let selector;
    if (this.selectedRecipient) selector = 'hide';
    if (this.selectedRecipient && this.selectedRecipient.short == recipient.short) selector = 'active';
    return selector;
  }

  submitStep() {
    let orderUpdates = {
      comments: this.recipientForm.value.comments || '',
      specs: {
        recipient: {
          type: this.selectedRecipient.name
        }
      }
    };
    let d = this.recipientForm.value;
    if (this.selectedRecipient.short == 'vessel' && this.recipientForm.valid) {
      orderUpdates = _.merge(orderUpdates, {
        specs: {
          recipient: {
            feet: d.feet.toString(),
            location: d.location,
            name: d.name
          }
        }
      });
    }
    this.shared.updateOrder(orderUpdates, 'location');
    return this.router.navigate(['account', 'request', 'location']);
  }

  feetChanged(event) {
    this.feetValue = event.value;
    this.recipientForm.patchValue({feet: event.value});
  }

  selectLocation(location) {
    this.selectedLocation = location.short;
    this.recipientForm.patchValue({location: location.name});
  }

}
